export const STATUS_COLOR_CLASS = {
  success: 'bg-success text-success-foreground',
  warning: 'bg-warning text-warning-foreground',
  info: 'bg-info text-info-foreground',
  danger: 'bg-danger text-danger-foreground',
  neutral: 'bg-muted text-muted-foreground',
} as const;

export type StatusColorTone = keyof typeof STATUS_COLOR_CLASS;

export const STATUS_TEXT_CLASS = {
  success: 'text-success-foreground',
  warning: 'text-warning-foreground',
  info: 'text-info-foreground',
  danger: 'text-danger-foreground',
  neutral: 'text-muted-foreground',
} as const satisfies Record<StatusColorTone, string>;

export const STATUS_SOLID_CLASS = {
  success: 'bg-success-foreground',
  warning: 'bg-warning-foreground',
  info: 'bg-info-foreground',
  danger: 'bg-danger-foreground',
  neutral: 'bg-muted-foreground',
} as const satisfies Record<StatusColorTone, string>;

export const APPROVAL_STATUS_TONE = {
  pending: 'warning',
  recommended: 'info',
  approved: 'success',
  rejected: 'danger',
} as const satisfies Record<string, StatusColorTone>;
